import { types } from 'mobx-state-tree';
import type { Instance } from 'mobx-state-tree';

export enum VIDEO_PROVIDERS {
    YOUTUBE = 'YOUTUBE',
    BILIBILI = 'BILIBILI',
    NONE = 'NONE',
}

export enum VIDEO_GROUPS {
    COMMUNITY_VIDEOS = 'COMMUNITY_VIDEOS',
    LEARN_STRATA_VIDEOS = 'LEARN_STRATA_VIDEOS',
    STRATA_TIPS_TOOLS = 'STRATA_TIPS_TOOLS',
}

const InformationModel = types.model('ExternalInformationModel', {
    id: 0,
    groupIds: types.array(
        types.enumeration<VIDEO_GROUPS>('VIDEO_GROUPS', Object.values(VIDEO_GROUPS))
    ),
    title: types.optional(types.string, ''),
    url: '',
    publishedDate: types.optional(types.string, ''),
    locale: '',
    tags: types.array(types.string),
    description: types.maybeNull(types.string),
    author: types.maybeNull(
        types.model('author', {
            authorName: '',
            authorUrl: '',
        })
    ),
    imageUrl: types.maybeNull(types.string),
    provider: types.maybeNull(
        types.enumeration<VIDEO_PROVIDERS>('VIDEO_PROVIDERS', Object.values(VIDEO_PROVIDERS))
    ),
    videoUrl: types.maybeNull(types.string),
    requiredService: types.maybeNull(types.string),
    views: 0.0,
});
const ExternalInformationModel = types.snapshotProcessor(InformationModel, {
    preProcessor(sn: TypeInformationModel) {
        return {
            ...sn,
            provider: sn?.provider?.toUpperCase(),
            publishedDate: sn.publishedDate?.split('-')?.join('/'),
        } as TypeInformationModel;
    },
});

type TypeInformationModel = Instance<typeof InformationModel>;
export type TypeExternalInformationModel = Instance<typeof ExternalInformationModel>;

export default ExternalInformationModel;
